import React from 'react';
import { useProduct } from '../ProductProvider';
import { UnitPrice } from '../UnitPrice';
/**
 * The `SelectedVariantUnitPrice` component renders a `UnitPrice` component for the product's selected variant's unit price.
 * It must be a descendent of a `ProductProvider`.
 */
export function SelectedVariantUnitPrice(props) {
    var _a, _b;
    const product = useProduct();
    if (product == null) {
        throw new Error('Expected a ProductProvider context, but none was found');
    }
    return ((_a = product.selectedVariant) === null || _a === void 0 ? void 0 : _a.unitPrice) &&
        ((_b = product.selectedVariant) === null || _b === void 0 ? void 0 : _b.unitPriceMeasurement) ? (React.createElement(UnitPrice, { ...props, unitPrice: product.selectedVariant.unitPrice, unitPriceMeasurement: product.selectedVariant.unitPriceMeasurement })) : null;
}
